import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import * as Sentry from '@sentry/react';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { Provider as ReduxProvider } from 'react-redux';
import AutoLogoutModal from '~/components/auto_logout_modal';
import ErrorHandler from '~/components/error_handler';
import Toast from '~/components_to_be_packaged/toast';
import { ToastProvider } from '~/components_to_be_packaged/toast/provider';
import { AuthProvider } from '~/providers/auth';
import { ErrorProvider } from '~/providers/error';
import { InactivityProvider } from '~/providers/inactivity';
import { UserProvider, useUser } from '~/providers/user';
import { WebsocketProvider } from '~/providers/websocket';
import GeniusRouter from '~/routes/router';
import store from '~/store';
const App = () => {
    const { id, name, email } = useUser();
    try {
        if (window.RG_CONFIG.ENVIRONMENT === 'prod') {
            window.Intercom('boot', {
                app_id: window.RG_CONFIG.INTERCOM_APP_ID,
                email: email,
                name: name,
                user_id: id,
            });
        }
    }
    catch (error) {
        console.error('Intercom failed to boot', error);
    }
    if (window.RG_CONFIG.SENTRY_DSN) {
        Sentry.init({
            dsn: window.RG_CONFIG.SENTRY_DSN,
            environment: window.RG_CONFIG.ENVIRONMENT,
            normalizeDepth: 10,
        });
    }
    return (React.createElement(ErrorProvider, null,
        React.createElement(ReduxProvider, { store: store },
            React.createElement(CookiesProvider, null,
                React.createElement(InactivityProvider, null,
                    React.createElement(AuthProvider, null,
                        React.createElement(UserProvider, null,
                            React.createElement(WebsocketProvider, null,
                                React.createElement(ToastProvider, null,
                                    React.createElement(ErrorHandler, null,
                                        React.createElement(GeniusRouter, null),
                                        React.createElement(AutoLogoutModal, null),
                                        React.createElement(Toast, { style: {
                                                bottom: window.RG_CONFIG.ENVIRONMENT === 'prod' ? '5rem' : '0',
                                            } }),
                                        React.createElement("div", { id: 'modal-portal-container' })))))))))));
};
export default App;
